export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organisations"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher une organisation..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune organisation"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "column_business_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raison sociale"])},
        "column_invoice_level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mode de facturation"])},
        "column_sales_channel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Canal de vente"])},
        "invoice_level": {
          "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organisation"])},
          "store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
          "billing_entity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entité juridique"])}
        },
        "source_channel": {
          "web": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Web"])},
          "retail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retail"])},
          "multichannel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Omnichannel"])}
        }
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organizations"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search an organization..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No organization"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "column_business_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Business name"])},
        "column_invoice_level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Billing mode"])},
        "column_sales_channel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales channel"])},
        "invoice_level": {
          "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organization"])},
          "store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
          "billing_entity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal entity"])}
        },
        "source_channel": {
          "web": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Web"])},
          "retail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retail"])},
          "multichannel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Omnichannel"])}
        }
      }
    }
  })
}
